import { HTMLAttributes, PropsWithChildren } from "react";
const WhimstayContainerNew = ({
  children,
  className = "",
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) => {
  return <div {...props} className={`mx-auto w-full max-w-[1448px] whitespace-pre-line px-4 lg:w-[calc(100%_-_80px)] lg:px-0 ${className}`} data-sentry-component="WhimstayContainerNew" data-sentry-source-file="WhimstayContainerNew.tsx">
      {children}
    </div>;
};
export default WhimstayContainerNew;